import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import RightTickIcon from "../RightTick";
import "./styles.scss";

const SelectOptionModal = ({
  visible,
  onClickBackdrop,
  heading,
  options,
  onSelect,
  name,
  value,
  isTranslated = false,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  const handleOnClick = (option) => {
    const event = { target: { name, value: option.value } };
    onSelect(event);
  };

  return (
    <div>
      <div
        className={`select-option-modal ${visible ? "show" : "hide"}`}
        onClick={onClickBackdrop}
      >
        <div
          className="card-modal-content"
          onClick={(event) => event.stopPropagation()}
        >
          <div className="handle" />
          <h2 className="heading">
            {routeName ? t(`${routeName}.${heading}`) : t(`app.${heading}`)}
          </h2>
          <div className="options">
            {options.map((option, index) => (
              <div
                key={index}
                className={`item ${option.value === value && "selected"}`}
                onClick={() => handleOnClick(option)}
              >
                {option.value === value ? (
                  <RightTickIcon
                    iconVariant={"default"}
                    iconColor={"primary-600"}
                  />
                ) : null}
                <p>
                  {isTranslated
                    ? routeName
                      ? t(`${routeName}.${option.label}`)
                      : t(`app.${option.label}`)
                    : option.label}
                </p>
              </div>
            ))}
          </div>
          <div className="handle double" />
        </div>
      </div>
    </div>
  );
};

export default SelectOptionModal;
